export default __webpack_public_path__ + "static/media/logo.f7aedac0.png";